import { featuredMovies } from '@/mocks/movies';
import MovieCard from '@/components/feature/MovieCard';

export default function FeaturedMovies() {
  return (
    <section className="py-12 md:py-16 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
              推荐大片
            </h2>
            <p className="text-sm text-foreground-500 mt-1">精选优质影片，不容错过</p>
          </div>
          <a href="#" className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap">
            查看全部 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6" data-product-shop>
          {featuredMovies.map((movie) => (
            <MovieCard
              key={movie.id}
              id={movie.id}
              title={movie.title}
              titleEn={movie.titleEn}
              category={movie.category}
              year={movie.year}
              rating={movie.rating}
              poster={movie.poster}
              slug={movie.slug}
              size="large"
            />
          ))}
        </div>
      </div>
    </section>
  );
}